import { endPoints } from '@/configs/endPoints'
import { ILogin, ILoginPromise } from '@/interfaces/authentication'
import { API } from '@/utils/fetcher'
import { API_DOMAIN_ACCESS } from '@/utils/domain-access-fetcher'
import { IAuthorizeVrAccessRequest, IAuthorizeVrAccessResponse } from '../interfaces/vrAccess'

export async function login(payload: ILogin): Promise<ILoginPromise | any> {
  const response = await API.post<ILoginPromise>(endPoints.auth, {
    username: payload.username,
    password: payload.password
  })

  return response
}

export async function authorizeVrAccess(data: IAuthorizeVrAccessRequest): Promise<IAuthorizeVrAccessResponse> {
  const response = await API_DOMAIN_ACCESS.post<IAuthorizeVrAccessResponse>(
    endPoints.deepLink,
    data
  )

  return response
}
